import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCamera = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9091 26C22.6477 26 24.8678 23.7614 24.8678 21C24.8678 18.2386 22.6477 16 19.9091 16C17.1705 16 14.9504 18.2386 14.9504 21C14.9504 23.7614 17.1705 26 19.9091 26Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.8347 30H10.9835C10.4574 30 9.95292 29.7893 9.58095 29.4142C9.20897 29.0391 9 28.5304 9 28V15C9 14.4696 9.20897 13.9609 9.58095 13.5858C9.95292 13.2107 10.4574 13 10.9835 13H14.9504L16.9339 10H22.8843L24.8678 13H28.8347C29.3608 13 29.8653 13.2107 30.2372 13.5858C30.6092 13.9609 30.8182 14.4696 30.8182 15V28C30.8182 28.5304 30.6092 29.0391 30.2372 29.4142C29.8653 29.7893 29.3608 30 28.8347 30Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3016 15.9091C12.3016 16.135 12.1185 16.3182 11.8926 16.3182C11.6666 16.3182 11.4835 16.135 11.4835 15.9091C11.4835 15.6832 11.6666 15.5 11.8926 15.5C12.1185 15.5 12.3016 15.6832 12.3016 15.9091Z",
			stroke: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgCamera);
export default ForwardRef;
